import tr from "./tr";
import en from "./en";
import de from "./de";

export default {
  en: en,
  tr: tr,
  de: de
};
